import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { useEffect } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import ClosIcon from "src/assets/svg-icons/close.svg";
import { LoadingButton } from "@mui/lab";
import { useActivateDriverMutation } from "src/api/delivery";

interface IProps {
  open: boolean;
  onClose: () => void;
  refetch: () => void;
  id: string;
}

const ActivateDriverPopup: React.FC<IProps> = (props) => {
  const { open, onClose, refetch, id } = props;
  const [notifications, setNotifications] = useRecoilState(notificationsState);

  // APIs
  const { mutate, isPending, status, error } = useActivateDriverMutation();

  const handleClose = () => {
    onClose();
  };

  const handleSubmit = () => {
    mutate({ id });
  };

  // activate driver success and error handling
  useEffect(() => {
    if (status === "success") {
      refetch();
      setNotifications((prev) => [
        ...prev,
        {
          type: "success",
          message: "The driver has been activated successfully!",
        },
      ]);
      handleClose();
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message:
            error?.data?.errors?.[0]?.message || "Oops! Something went wrong.",
        },
      ]);
    }
  }, [status, error]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      onClose={handleClose}
      component={"div"}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
          bgcolor: "#191919",
        },
      }}
    >
      <DialogTitle sx={{ p: "30px 30px 20px 30px" }}>
        <Box display={"flex"} alignItems={"center"}>
          <Typography fontSize={"22px"} fontWeight={600} lineHeight={"22px"}>
            Are you sure?
          </Typography>
          <IconButton size="small" sx={{ ml: "auto" }} onClick={handleClose}>
            <img src={ClosIcon} alt="close" />
          </IconButton>
        </Box>
        <Typography fontSize={"14px"} mt={2}>
          This action will move this driver from the archived drivers list to
          the active list.
        </Typography>
      </DialogTitle>
      <DialogActions sx={{ padding: "31px", gap: "12px" }}>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <LoadingButton
          loading={isPending}
          variant="contained"
          onClick={handleSubmit}
        >
          Activate
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ActivateDriverPopup;
